import axios from 'axios'

function decodeRegister(obj) {
    return new Promise((resolve, reject) => {
        try {
            let port = ""
            if (process.env.ROOT_API.includes("viewmedonline"))
                port = ":3037"
            axios({
                    method: 'post',
                    headers: {
                        'Authorization': obj.token
                    },
                    url: process.env.ROOT_API + "/decode_register"
                })
                .then(result => {
                    resolve(result.data.documents[0])
                })
                .catch(error => {
                    reject(error.response.data.message)
                })
        } catch (err) {
            console.log('err in decodeRegister: ', err)
        }
    })
}

function insertUser(objUser) {
    return new Promise((resolve, reject) => {
        try {
            let port = ""
            if (process.env.ROOT_API.includes("viewmedonline"))
                port = ":3014"
            axios
                .post(process.env.ROOT_API + "/users/insert", {
                    user: objUser.user,
                    passwd: objUser.passwd,
                    role: objUser.role,
                    language : objUser.language
                }, {
                    headers: {
                        'Authorization': objUser.token
                    }
                })
                .then(result => {
                    resolve(result.data.documents[0]);
                })
                .catch(error => {
                    reject(error);
                });
        } catch (err) {
            console.log("err in insertUser: ", err);
        }
    });
}

function insertPersons(objPersons) {
    return new Promise((resolve, reject) => {
        try {
            let port = ""
            if (process.env.ROOT_API.includes("viewmedonline"))
                port = ":3033"
            axios
                .post(process.env.ROOT_API + "/persons/insert", objPersons, {
                    headers: {
                        'Authorization': objPersons.token
                    }
                })
                .then(result => {
                    resolve(result.data.documents[0]);
                })
                .catch(error => {
                    reject(error.response);
                });
        } catch (err) {
            console.log("err in insertPersons: ", err);
        }
    });
}

function insertInstitution(objInst) {
    return new Promise((resolve, reject) => {
        try {
            let port = ""
            if (process.env.ROOT_API.includes("viewmedonline"))
                port = ":3008"
            axios.post(process.env.ROOT_API + "/institutions/insert", {
                name: objInst.name,
                user: objInst.idUser,
                category: objInst.category,
                email: objInst.user
            }, {
                headers: {
                    'Authorization': objInst.token
                }
            }).then(result => {
                resolve(result.data.documents[0])
            }).catch(error => {
                reject(error)
            })
        } catch (error) {
            console.log('error in insertInstitution: ', error)
        }
    })
}

function updatePassword(objUser) {
    return new Promise((resolve, reject) => {
        let port = ""
        if (process.env.ROOT_API.includes("viewmedonline"))
            port = ":3017"
        axios.put(process.env.ROOT_API + "/users/update/" + objUser.id, {
            passwd: objUser.passwd,
            control: {
                updated_by: objUser.id
            }
        }, {
            headers: {
                Authorization: objUser.token
            }
        }).then(result => {
            resolve(result.data.documents)
        }).catch(error => {
            reject(error.response.data.message)
        })
    })
}

function personsExists(objUser) {
    return new Promise((resolve, reject) => {
        let port = ""
        if (process.env.ROOT_API.includes("viewmedonline"))
            port = ":3032"
        axios.get(process.env.ROOT_API + "/persons/exists/" + objUser.email, {
            headers: {
                Authorization: objUser.token
            }
        }).then(result => {
            resolve(result.data.documents[0])
        }).catch(error => {
            reject(error.response)
        })
    })
}

function personsUpdate(objPersons) {
    return new Promise((resolve, reject) => {
        let port = ""
        if (process.env.ROOT_API.includes("viewmedonline"))
            port = ":3035"
        axios.put(process.env.ROOT_API + "/persons/update/" + objPersons.id, {
            forename: objPersons.forename,
            surname: objPersons.surname,
            user: objPersons.user
        }, {
            headers: {
                Authorization: objPersons.token
            }
        }).then(result => {
            resolve(result.data.documents[0])
        }).catch(error => {
            reject(error.response)
        })
    })
}
function saveMsjContact(obj) {
    return new Promise((resolve, reject) => {
        let port = ""
        if (process.env.ROOT_API.includes("viewmedonline"))
            port = ":3035"
        axios.post(process.env.ROOT_API + "/contactUs/insert", obj.body).then(result => {
            resolve(result.data.documents[0])
        }).catch(error => {
            reject(error.response)
        })
    })
}
export {
    decodeRegister,
    insertUser,
    insertPersons,
    insertInstitution,
    updatePassword,
    personsExists,
    personsUpdate,
    saveMsjContact
}



// WEBPACK FOOTER //
// ./src/components/home/homeServ.js